<app-report-self-inspection-wrapper
  [data]="wrapperData"
  [isLoading$]="isLoading$"
  [showWaring]="showWarning"
>
  <app-text-input
    [data]="data"
    [canBeMarkedNotApplicable]="canBeMarkedNotApplicable"
    (saveInput)="saveInput($event)"
    (hasUnsavedChanges)="handleHasUnsavedChanges($event)"
  />
</app-report-self-inspection-wrapper>
